import {
  Sparkles, Wand2, Moon, Sun, Star, Flower2, Crown, Key, Heart, Shield,
  PawPrint, Compass, Disc3, Scale, Hourglass, Skull, Droplets, Flame, Zap,
  Bell, Globe, Sword, Coins, Droplet, Bird, Rabbit, Turtle, Waves, Mountain,
  TreePine, Bug, Sprout, Cloud, CloudRain, Sunrise, Sunset, Orbit,
} from "lucide-react";

export const ICONS = {
  Sparkles, Wand2, Moon, Sun, Star, Flower2, Crown, Key, Heart, Shield,
  PawPrint, Compass, Disc3, Scale, Hourglass, Skull, Droplets, Flame, Zap,
  Bell, Globe, Sword, Coins, Droplet, Bird, Rabbit, Turtle, Waves, Mountain,
  TreePine, Bug, Sprout, Cloud, CloudRain, Sunrise, Sunset, Orbit,
};

export const getIcon = (name) => ICONS[name] || Sparkles;
